import EntitlementIcon from './entitlement-icon';
export default EntitlementIcon;
